import { createContext } from "react";


class EventsCategoriesStore {
  globalFilter = undefined
  searchField = 'name'
  // State preservation fields
  tableData = []
  isLoading = true
  isRefetching = false
  open = false
  scrollTop = 0
  needsRefresh = false
}


export const eventsCategoriesStore = new EventsCategoriesStore()
export const EventsCategoriesStoreContext = createContext(eventsCategoriesStore)
